import { IS_SIDE_MODE_KEY } from '@portals/help-center-core/lib/_internal';

export const GO_BACK_OPTION = 'goBackOption';
export const MATERIAL_CATEGORY_ID = 'categoryId';
const SEARCH_TEXT = 'searchText';
const HIDE_BACK_BUTTON = 'hideBackButton';
const RECOMMENDED = 'recommended';
const SLUG = 'slug';

export enum EGoBackOption {
  PREV_ROUTE = 'prevRoute',
}

export type TSearchParams = {
  [IS_SIDE_MODE_KEY]?: 'true' | 'false';
  [GO_BACK_OPTION]?: EGoBackOption;
  [MATERIAL_CATEGORY_ID]?: string;
  [SEARCH_TEXT]?: string;
  [SLUG]?: string;
  [HIDE_BACK_BUTTON]?: 'true' | 'false';
  [RECOMMENDED]?: 'true' | 'false';
};
